import { AppBar, Toolbar, IconButton, Typography, Grid, FormControlLabel, Switch } from "@mui/material";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import MapIcon from '@mui/icons-material/Map';
import { useHistory } from "react-router-dom";

function NavBar({ color, title, subtitle, onAdminToggle, map, extra, backBtnNavigateHome, isAdminView }) {
    const history = useHistory();

    const handleClick = () => {
        if (backBtnNavigateHome && backBtnNavigateHome === true) {
            history.replace('/');
        } else {
            history.goBack();
        }
    };

    const openGoogleMaps = (map) => {
        if (!map || !map?.latitude || !map?.longitude) {
            console.error("Error opening google maps.");
            return;
        }
        let longitude = map.longitude;
        let latitude = map.latitude;

        let url = `https://maps.google.com/?q=${latitude},${longitude}`;
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };

    return (
        <AppBar position="static">
            <Toolbar sx={{ paddingTop: "1rem", paddingBottom: "1rem", backgroundColor: color, color: "#fff" }}>
                <Grid container alignItems="center">
                    <Grid item xs={2}>
                        <IconButton edge="start" color="inherit" onClick={handleClick}>
                            <ArrowBackRounded fontSize="large" />
                        </IconButton>
                    </Grid>
                    <Grid item xs={onAdminToggle ? 6 : 8} container direction="column" alignItems="center">
                        <Grid item>
                            {title && (
                                <Typography variant="h5" align="center">
                                    {title}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item sx={{ maxWidth: "100%", wordBreak: "break-word" }}>
                            {subtitle && <Typography variant="h6">{subtitle}</Typography>}
                        </Grid>
                    </Grid>
                    <Grid item xs={2}>
                        {map && (
                            <IconButton edge="start" color="inherit" aria-label="Maps" onClick={() => openGoogleMaps(map)}>
                                <MapIcon fontSize="large" />
                            </IconButton>
                        )}
                        {extra && !map && <>{extra}</>}
                    </Grid>

                    {onAdminToggle && (
                        <Grid item xs={2}>
                            <FormControlLabel
                                sx={{ margin: 0 }}
                                labelPlacement="top"
                                control={
                                    isAdminView !== undefined
                                        ? <Switch size="small" onChange={onAdminToggle} checked={isAdminView} name="Admin switch view" color="primary" />
                                        : <Switch size="small" onChange={onAdminToggle} name="Admin switch view" color="primary" />
                                }
                                label="Admin"
                            />
                        </Grid>
                    )}
                </Grid>
            </Toolbar>
        </AppBar>
    );
}

export default NavBar;
